import { Layout, Menu, Button, Typography, Dropdown, Avatar, theme } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined, BellOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import React from 'react';

const { Header } = Layout;
const { Title, Text } = Typography;

const DashboardHeader = React.memo(() => {
    const { user, signOut, isAdmin } = useAuth();
    const { token } = theme.useToken();
    const navigate = useNavigate();

    const profileMenuItems = [
        {
            key: 'email',
            disabled: true,
            label: (
                <div className="px-2 py-1">
                    <Text type="secondary" style={{ fontSize: '12px' }}>Signed in as</Text>
                    <div style={{ wordBreak: 'break-all' }}>{user?.email} {user?.name}</div>
                </div>
            )
        },
        /*
        { type: 'divider' },
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: 'Profile Settings',
            onClick: () => navigate('/profile')
        },
        */
        { type: 'divider' },
        {
            key: 'signout',
            icon: <LogoutOutlined />,
            danger: true,
            onClick: signOut,
            label: 'Sign Out'
        }
    ];

    const allNavigationItems = [
        {
            key: 'dashboard',
            label: 'Dashboard',
            onClick: () => navigate('/')
        },
        {
            key: 'domains',
            label: 'Domains',
            onClick: () => navigate('/domains')
        },
        {
            key: '/admin/payments',
            label: 'Backend',
            adminOnly: true,
            onClick: () => navigate('/admin/payments')
        }/*,
        {
            key: 'settings',
            label: 'Settings',
            onClick: () => navigate('/settings')
        }*/
    ];
    const navigationItems = allNavigationItems.filter(item => !item.adminOnly || isAdmin);

    return (
        <Header style={{
            background: '#fff',
            padding: '0 24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            width: '100%'
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '100%'
            }}>
                <div className="left-section" style={{ display: 'flex', alignItems: 'center' }}>
                    <Title 
                        level={4} 
                        style={{ 
                            margin: 0,
                            marginRight: '48px',
                            color: token.colorPrimary
                        }}
                    >
                        <img 
                            src='https://bvorqhdsibaukalonivs.supabase.co/storage/v1/object/public/images/public/0.7309657142709678-Vector%20(5).png' 
                            height={30} 
                            alt="Logo"
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate('/')}
                        />
                    </Title>
                    <Menu 
                        mode="horizontal" 
                        defaultSelectedKeys={['dashboard']}
                        style={{
                            border: 'none',
                            flex: 1
                        }}
                        items={navigationItems}
                    />
                </div>

                <div className="right-section" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Button 
                        type="primary"
                        icon={<BellOutlined />}
                        style={{
                            border: 'none',
                            background: 'transparent',
                            color: token.colorTextSecondary,
                            boxShadow: 'none'
                        }}
                    />
                    <Dropdown 
                        menu={{
                            items: profileMenuItems,
                            style: { minWidth: '200px' }
                        }}
                        trigger={['click']}
                        placement="bottomRight"
                    >
                        <Button 
                            type="text"
                            style={{
                                height: '40px',
                                padding: '0 8px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <Avatar 
                                icon={<UserOutlined />}
                                style={{
                                    backgroundColor: token.colorPrimary,
                                }}
                            />
                            <SettingOutlined style={{ color: token.colorTextSecondary }} />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </Header>
    );
});

export default DashboardHeader;